import Placeholder from '@atlaskit/react-ufo/placeholder';
import { ErrorBoundary } from '@sentry/react';

import { LoadingSkeleton } from '../common/components/skeleton/skeleton';
import { DevAgentIntlProvider } from '../services/intl-provider';
import { useAnalyticsWebClient } from '../utils/analytics/context';

import { AppRouteComponent } from './app/app-route';
import { BlockingAtlassianProviders } from './app/providers';

export const App = () => {
	const analyticsWebClient = useAnalyticsWebClient();

	return (
		<ErrorBoundary
			onError={(err) => {
				analyticsWebClient.sendOperationalEvent({
					action: 'error',
					actionSubject: 'appComponent',
					source: 'app',
					attributes: {
						message: err.message,
					},
				});
			}}
		>
			<Placeholder name="dev-agents-app" fallback={<LoadingSkeleton />}>
				<DevAgentIntlProvider>
					<BlockingAtlassianProviders>
						<AppRouteComponent />
					</BlockingAtlassianProviders>
				</DevAgentIntlProvider>
			</Placeholder>
		</ErrorBoundary>
	);
};
